export default (width = 26, height = 26, color = '#F5F5F5') => `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 26 26">
        <defs>
            <circle id="a" cx="13" cy="13" r="13"/>
            <mask id="b" width="26" height="26" x="0" y="0" fill="#fff">
                <use xlink:href="#a"/>
            </mask>
        </defs>
        <use fill="${color}" fill-rule="evenodd" stroke="#309A02" stroke-dasharray="3,2" stroke-width="4" mask="url(#b)" xlink:href="#a"/>
    </svg>
`